import { Component, OnInit, OnDestroy, HostListener, Input, Inject } from '@angular/core';

import { Router , NavigationStart,
  NavigationEnd,
  NavigationCancel,
  NavigationError} from '@angular/router';
import { DOCUMENT } from '@angular/common';


@Component({
  selector: 'app-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.scss']
})

export class LoaderComponent implements OnInit {

  public loader: boolean = true;
  
  constructor(
    private router: Router
  ) {
    this.router.events.subscribe(
      event => {
        if (event instanceof NavigationStart) {
          this.loader = true;
          // console.log("hello router",event,this.loader)
        
        } else if (event instanceof NavigationEnd || event instanceof NavigationCancel || event instanceof NavigationError){
          // this.loader = false;
            setTimeout(() => {
            this.loader = false;
          }, 200);
          // console.log("hello routerend",event,this.loader)
        }
      },
      () => {
        this.loader = false;
      }
    )
       setTimeout(() => {
            this.loader = false;
          }, 2000);
  }

  ngOnInit(): void {
    setTimeout(() => {
      this.loader = false;
    }, 200);
  }

  ngOnDestroy(){
    this.loader = false;
  }

}



